<template>
  <slot>
    <button type="submit" :disabled="state.readOnly" :id="identifier" class="idsk-button" v-on:click="clickEvent" v-html="displayName"></button>
  </slot>
</template>
<script lang="ts" src="@/library/templates/default/controls/Button.ts"></script>
